import axios from 'axios';
import {
  ApprovalChainApiFactory,
  AssetApiFactory,
  Configuration,
  EndOfLeaseApiFactory,
  MidLeaseApiFactory,
  InvoicingAccountApiFactory,
  OrganizationApiFactory,
  ReportApiFactory,
  UserApiFactory,
  UserGroupApiFactory,
} from '@cdaas/api-clients/dist/asset-admin-openapi';
import { DefaultApiFactory } from '@cdaas/api-clients/dist/asset-feature-flag-openapi';

const assetAdminConfig = new Configuration({
  basePath: process.env.REACT_APP_ASSET_SERVICE_URL,
});

export const assetAdminOrganizationClient = OrganizationApiFactory(assetAdminConfig, undefined, axios);
export const assetAdminUserClient = UserApiFactory(assetAdminConfig, undefined, axios);
export const assetAdminUserGroupClient = UserGroupApiFactory(assetAdminConfig, undefined, axios);
export const assetAdminClient = AssetApiFactory(assetAdminConfig, undefined, axios);
export const assetAdminInvoicingAccountClient = InvoicingAccountApiFactory(assetAdminConfig, undefined, axios);
export const assetAdminApprovalChainClient = ApprovalChainApiFactory(assetAdminConfig, undefined, axios);
export const assetFeatureFlagsClient = DefaultApiFactory(assetAdminConfig, undefined, axios);
export const assetReportClient = ReportApiFactory(assetAdminConfig, undefined, axios);
export const assetEndOfLeaseClient = EndOfLeaseApiFactory(assetAdminConfig, undefined, axios);
export const assetMidLeaseClient = MidLeaseApiFactory(assetAdminConfig, undefined, axios);
